import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import "./sliderStyles.css"; // Custom CSS file

const Sliderdiv = () => {
  const images = [
    { src: "/img/WhatsApp Image 2025-01-09 at 13.15.14_2f75f361.jpg", alt: "Project 1" },
    { src: "/img/WhatsApp Image 2025-01-09 at 13.15.17_67dca11e.jpg", alt: "Project 2" },
    { src: "/img/WhatsApp Image 2025-01-09 at 13.15.17_78dfd245.jpg", alt: "Project 3" },
    { src: "/img/WhatsApp Image 2025-01-09 at 13.15.17_86a25d22.jpg", alt: "Project 4" },
    { src: "/img/WhatsApp Image 2025-01-09 at 13.15.17_93bb8409.jpg", alt: "Project 5" },
    { src: "/img/WhatsApp Image 2025-01-09 at 13.15.17_a3ed6603.jpg", alt: "Project 6" },
    { src: "/img/WhatsApp Image 2025-01-09 at 13.15.17_3b7547bf.jpg", alt: "Project 7" },
    { src: "/img/WhatsApp Image 2025-01-12 at 09.05.45_a73a112b.jpg", alt: "Project 7" },
  ];
  
  const PrevArrow = ({ onClick }) => (
    <button className="left-arrownew" onClick={onClick}>
      &#9665;
    </button>
  );
  
  const NextArrow = ({ onClick }) => (
    <button className="right-arrownew" onClick={onClick}>
      &#9655;
    </button>
  );
  const settings = {
    dots: false, // Hide bullet indicators
    infinite: true,
    speed: 500,
    slidesToShow: 4, // Show 4 images at a time
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };
  return (
    <>
      <div
        id="our_project"
        data-ride="carousel"
        class="full_wrapper variation2_projectsection_bg padtb_91_0 carousel slide three_shows_one_move"
        style={{
          background: "url(/img/project_bg.jpg) no-repeat center top",
          backgroundSize: "cover",
        }}
      >
        <div class="container">
          <h3 class="fnt_white_color mbot25">Our Projects</h3>
          <p class="p_gray1 mbot45">
            At Technociv Technologies, we specialize in delivering advanced
            automated solutions tailored for the automotive industry. Our core
            expertise lies in the development of sophisticated test systems for
            critical components such as DC-DC converters, battery chargers, and
            motor controller units.
            <ul >
              
              <li>END OF LINE FOR  DC-DC Convertor</li>
              <li>END OF LINE FOR  OFF BOARD CHARGER</li>
              <li>END OF LINE FOR  MOTOR CONTROLLER UNIT </li>
              <li>PCB DEVELOPMENT </li>
              <li>SUPPLIES OF TEST AND MEASURING INSTRUMENTS</li>
              <li>JIGS AND FIXTURE FOR EOL</li>
              <li>CUSTOMISED WORKSTATION </li>
              <li>BURN IN CHAMBER </li>
              <li>WATER IMMERSION TANK IP7 & IP8</li>
              <li>COMPOSITE TESTER WITH HYDRAULIC SYSTEM</li>
        </ul>
          </p>
          {/* <div class="controls pull-right mtop165">
            <a
              href="#our_project"
              data-slide="prev"
              class="left fa fa-angle-left next_prve_control"
            ></a>
            <a
              href="#our_project"
              data-slide="next"
              class="right fa fa-angle-right next_prve_control"
            ></a>
          </div> */}
        </div>
        <div className="slider-container">
      <Slider {...settings}>
        {images.map((img, index) => (
          <div key={index} className="slide">
            <div className="project_img effect-goliath">
              <div className="shadow_effect black_overlay">
                <img src={img.src} alt={img.alt} className="img-responsive" />
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
      </div>
      <div class="full_wrapper worker_bg padtb_91_50">
        <div class="container">
          <h3 class="mbot45">Our Team</h3>
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mtopminus10">
              <p>
                At Technociv Technologies, we are a dedicated team of engineers
                united by a singular mission: to deliver the highest quality
                services at competitive prices. Our diverse educational
                backgrounds, spanning various engineering disciplines, equip us
                with a broad perspective and a unique ability to thoroughly
                understand and meet the diverse needs of our clients.
              </p>
              <p>
              Our engineers bring a wealth of expertise and creativity, allowing us to tackle complex challenges and develop innovative solutions tailored to each project's requirements. We believe that collaboration and knowledge-sharing are key to our success, fostering an environment where ideas can flourish and the best solutions can emerge.
              </p>
              <p>
              With a commitment to excellence, we ensure that our services not only meet but exceed industry standards, providing our clients with the reliability and performance they expect. Our team’s dedication to continuous learning and adaptation enables us to stay ahead in a rapidly evolving technological landscape, ensuring that we remain a trusted partner in your success.
              </p>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 col_margin">
              <div
                id="our_worker"
                data-ride="carousel"
                class="carousel slide four_shows_one_move"
              >
                <div class="controls pull-right">
                  <a
                    href="#our_worker"
                    data-slide="prev"
                    class="left fa fa-angle-left next_prve_control"
                  ></a>
                  <a
                    href="#our_worker"
                    data-slide="next"
                    class="right fa fa-angle-right next_prve_control"
                  ></a>
                </div>
                <div class="row">
                  <div id="teamCarousel" class="carousel slide" data-ride="carousel">
                    <div class="carousel-inner">
                      {/* <!-- Team Member 1 --> */}
                      <div class="item active">
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 text-center">
                          <div class="dedicated-team-img-holder mbot15">
                            <div class="">
                              <img src="/img/WhatsApp_Image_2025-01-09_at_13.19.03_9bf55cb0-removebg-preview.png" alt="team1" />
                            </div>
                            {/* <div class="overlay">
                              <div class="inner-holder">
                                <ul>
                                  <li><a href="#"><i class="fa fa-facebook"></i></a></li>
                                  <li><a href="#"><i class="fa fa-twitter"></i></a></li>
                                  <li><a href="#"><i class="fa fa-linkedin"></i></a></li>
                                  <li><a href="#"><i class="fa fa-google-plus"></i></a></li>
                                </ul>
                              </div>
                            </div> */}
                          </div>
                          {/* <!-- Name and Designation --> */}
                          <span class="team_name full_width">SUMIT SINHA</span>
                          <span class="team_designation full_width">Director</span>
                          <span class="team_designation full_width">B.Tech, MBA (Project Management)</span>
                        </div>
                        {/* <!-- Overview Section --> */}
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                          <p>
                            <strong>Overview:</strong> Sumit Sinha brings a wealth of knowledge in engineering and project management. His leadership has been instrumental in spearheading cutting-edge projects like the LG Composite Tester for R&D labs.
                          </p>
                          <p>
                            <strong>Vision Statement:</strong> "To transform engineering challenges into reliable and impactful solutions through innovation and teamwork."
                          </p>
                        </div>
                      </div>

                      {/* <!-- Team Member 2 --> */}
                      <div class="item">
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 text-center">
                          <div class="dedicated-team-img-holder mbot15">
                            <div class="shadow_effect effect-apollo">
                              <img src="/img/WhatsApp Image 2025-01-09 at 13.15.14_858b3ef3.jpg" alt="team2" />
                            </div>
                            {/* <div class="overlay">
                              <div class="inner-holder">
                                <ul>
                                  <li><a href="#"><i class="fa fa-facebook"></i></a></li>
                                  <li><a href="#"><i class="fa fa-twitter"></i></a></li>
                                  <li><a href="#"><i class="fa fa-linkedin"></i></a></li>
                                  <li><a href="#"><i class="fa fa-google-plus"></i></a></li>
                                </ul>
                              </div>
                            </div> */}
                          </div>
                          {/* <!-- Name and Designation --> */}
                          <span class="team_name full_width">SWEETY KALPA</span>
                          <span class="team_designation full_width">Director</span>
                          <span class="team_designation full_width">B.Tech (Electronics and Communication Engineering)</span>
                        </div>
                        {/* <!-- Overview Section --> */}
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                          <p>
                            <strong>Overview:</strong> Sweety Kalpa combines technical expertise with a creative approach to problem-solving. Her background in Electronics and Communication Engineering has been pivotal in designing robust and efficient systems. She is passionate about pushing the boundaries of technology to deliver excellence.
                          </p>
                          <p>
                            <strong>Vision Statement:</strong> "o empower businesses with advanced, reliable, and cost-effective engineering solutions."
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* <!-- Carousel Controls --> */}
                    <a class="left carousel-control" href="#teamCarousel" data-slide="prev">
                      <span class="glyphicon glyphicon-chevron-left"></span>
                    </a>
                    <a class="right carousel-control" href="#teamCarousel" data-slide="next">
                      <span class="glyphicon glyphicon-chevron-right"></span>
                    </a>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sliderdiv;
